<template>
	<div
		id="subscribe_short"
		class="panel form subscribe-short theme-light"
	>
		<div class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12">
						<div class="title">
							Обратная связь
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-lg-6 order-lg-1">
					<div class="overview_block">
						<div class="description">
							Преподавателю можно задать вопрос через обратную связь
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="subscribe_block">
						<form action="" @submit.prevent="formSubmit">
							<div class="form-row">
								<div
									class="form-group col-12 col-md-6 col-lg-6"
									:class="{ 'form-group--error': $v.firstName.$error }"
								>
									<input
										:id="'first_name_' + author.id"
										v-model.trim="$v.firstName.$model"
										data-msg="Пожалуйста, укажите ваше имя"
										name="first_name"
										placeholder="Имя*"
										type="text"
										class="form-control rounded-0 required"
									>
									<label
										v-if="!$v.firstName.required"
										v-model.trim="$v.firstName.$model"
										class="error"
										:for="'first_name_' + author.id"
									>Пожалуйста, укажите ваше имя</label>
								</div>
								<div
									class="form-group col-12 col-md-6 col-lg-6"
									:class="{ 'form-group--error': $v.lastName.$error }"
								>
									<input
										:id="'last_name_' + author.id"
										v-model.trim="lastName"
										data-msg="Пожалуйста, укажите вашу фамилию"
										name="last_name"
										placeholder="Фамилия*"
										type="text"
										class="form-control rounded-0 required"
									>
									<label
										v-if="!$v.lastName.required"
										v-model.trim="$v.lastName.$model"
										class="error"
										:for="'last_name_' + author.id"
									>Пожалуйста, укажите вашу фамилию</label>
								</div>
								<div
									class="form-group col-12"
									:class="{ 'form-group--error': $v.email.$error }"
								>
									<input
										:id="'email_' + author.id"
										v-model="email"
										data-msg="Пожалуйста, укажите ваш email"
										name="email"
										type="email"
										placeholder="Email*"
										class="form-control rounded-0 required"
									>
									<label
										v-if="!$v.email.required"
										v-model.trim="$v.email.$model"
										class="error"
										:for="'email_' + author.id"
									>Пожалуйста, укажите ваш email</label>
									<label
										v-if="!$v.email.email"
										v-model.trim="$v.email.$model"
										class="error"
										:for="'email_' + author.id"
									>Пожалуйста, укажите ваш email</label>
								</div>

								<div

									class="form-group col-12"
									:class="{ 'form-group--error': $v.comment.$error }"
								>
									<textarea
										:id="'comments_' + author.id"
										v-model="comment"
										name="comments"
										type="text"
										:placeholder="'Какой вопрос вы бы хотели задать преподавателю?'"
										:class="['form-control', 'rounded-0', 'w-100']"
									/>

									<label
										v-if="!$v.comment.length"
										v-model.trim="$v.comment.$model"
										class="error"
										:for="'comments_' + author.id"
									>Длина сообщения не должна превышать 300 символов</label>
								</div>
							</div>
							<div class="form-row">
								<div
									class="form-group col-12 custom-control custom-checkbox"
									:class="{ 'form-group--error': $v.agreements.personal_data.$error }"
								>
									<div v-if="showPersonalData" class="form-check">
										<input
											:id="'condition_checkbox_' + author.id"
											v-model="agreements.personal_data"
											data-msg="Необходимо принять условия"
											name="terms"
											type="checkbox"
											class="rounded-0 required form-check-input custom-control-input"
											value="personal-data"
											data-action="feedbackform-personal-data-processing-agreement"
										>
										<label
											class="custom-control-label form-check-label"
											:for="'condition_checkbox_' + author.id"
										>
											Согласен с
											<a
												href="/static/personaldata_rus.html"
												target="_blank"
											>условиями обработки и хранения персональных данных</a>
										</label>
										<label
											v-if="!$v.agreements.personal_data.checked"
											v-model.trim="$v.agreements.personal_data.$model"
											class="error"
											:for="'condition_checkbox_' + author.id"
										>Необходимо принять условия</label>
									</div>
									<div v-if="showMarketingEmails" class="form-check">
										<input
											:id="'marketing_checkbox_' + author.id"
											v-model="agreements.marketing_emails"
											type="checkbox"
											name="marketingEmailsAgreement"
											class="custom-control-input"
											data-action="feedbackform-marketing-emails-agreement"
										>
										<label
											class="custom-control-label"
											for="marketing_checkbox"
										>{{ $t('isAgreesToMarketingEmails') }}</label>
									</div>
								</div>
							</div>
							<div class="form-row">
								<div class="form-group col-12 pb-0">
									<button type="submit" class="btn btn-primary">
										Задать вопрос
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { email, maxLength, required } from 'vuelidate/lib/validators';

import axios from 'axios';
import agreementsMixin from '~/mixins/agreementsMixin';

export default {
	name: 'SubscribeShort',
	mixins: [validationMixin, agreementsMixin],
	props: {
		author: { type: Object, required: true },
	},
	validations() {
		return {
			firstName: {
				required,
				maxLength: maxLength(150),
			},
			lastName: {
				required,
				maxLength: maxLength(150),
			},
			email: {
				required,
				email,
			},
			agreements: this.agreements_validation,
			comment: {
				maxLength: maxLength(300),
			},
		};
	},
	data() {
		return {
			firstName: '',
			lastName: '',
			email: '',
			landingId: '',
			comment: '',
		};
	},
	methods: {
		formSubmit() {
			this.$v.$touch();

			if (this.$v.$invalid) {
				return;
			}

			this.setAgreementFields();

			const leadData = this.makeLeadData();

			axios({
				url: `${process.env.baseURL}/api/v2/leadsintegration/save`,
				data: leadData,
				method: 'post',
				contentType: 'application/x-www-form-urlencoded',
				crossDomain: true,
				async: false,
			}).then(() => {
				alert('Спасибо за подписку!');
			}).catch(() => {
				alert('Спасибо за подписку!');
			});
		},

		makeLeadData() {
			const clientID = typeof yaCounter994527 !== 'undefined'
				? yaCounter994527.getClientID()
				: '';
			const { UAClientID } = window;
			const BpmRef = this.$cookies.get('bpmRef') || '';
			const BpmHref = this.$cookies.get('bpmHref') || '';
			const roistatVisitId = this.$cookies.get('roistat_visit') || '';

			const leadData = {
				landingId: this.landingId,
				leadFields: {
					TsContactGivenName: this.firstName,
					TsContactSurname: this.lastName,
					Email: this.email,
					SkGAClientId:
						typeof UAClientID !== 'undefined' ? UAClientID : '',
					SkYMClientId:
						typeof clientID !== 'undefined' ? clientID : '',
					roistatVisitId:
						typeof roistatVisitId !== 'undefined' ? roistatVisitId : '',
					BpmRef,
					BpmHref,
					TsAdditionalInformation: 'email-подписка',
					sklAgreeSubscribeLookup: this.agreements.marketing_emails ? 'да' : 'нет',
					sklAgreedPersonalData: this.agreements.personal_data,
				},
			};

			return leadData;
		},
	},
};
</script>
<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-subscribe-short";
	// Это исключить при программировании панели что бы не было дубликтов, т.к. использоваться будет общий стиль для смарт-формы
	@import "~/assets/styles/components/home/panel-smart-form";
</style>
